import store from '@/store/store'

export default {

  /** デバッグ用：画面上部のデバッグ情報の表示 **/
  isDebug () {
    return false // 製品出荷時
    // return true // デバッグ時
  },

  /** デバッグ用: 確認テストのランダム化の有効化状態 */
  isQuestionRandom () {
    return true // 製品出荷時
    // return false // デバッグ時
  },

  /**
   * isSignedIn
   * サインインされていた場合, trueを返す
   * サインアウトされていた場合, falseを返す
   */
  isSignedIn () {
    const token = this.getIdToken()
    return store.state.user !== null || token !== null
  },

  /**
   * User
   * サインイン中の場合に, 以下の情報を格納する
   * 例:)
   * const user = getUser() -> { "pjmUserId": 1, "corpUserId": "testuser001" }
   */
  setPjmUserId (userId) {
    store.state.user.pjmUserId = userId
  },
  getPjmUserId () {
    return store.state.user.pjmUserId || null
  },
  removeUser () {
    localStorage.removeItem('pjmUserId')
  },

  /**
   * IdToken
   * サインイン中の場合に, Cognitoからの IdTokenを格納する
   */
  setIdToken (idToken) {
    store.state.idToken = idToken
  },
  getIdToken () {
    return store.state.idToken
  },
  removeIdToken () {
    localStorage.removeItem('idToken')
  },

  /**
   * AccessToken
   * サインイン中の場合に, Cognitoからの AccessTokenを格納する
   */
  setAccessToken (accessToken) {
    store.state.accessToken = accessToken
  },
  getAccessToken () {
    return store.state.accessToken
  },
  removeAcceessToken () {
    localStorage.removeItem('acceessToken')
  },

  /**
   * registCourseId
   */
  setRegistCourseId (id) {
    store.state.registCourseId = id
  },
  getRegistCourseId () {
    return store.state.registCourseId
  },
  removeRegistCourseId () {
    localStorage.removeItem('registCourseId')
  },

  /**
   * ClearAll
   * すべてのrepository要素をリセットする
   * 実態としてはlocalstorageの要素をクリア
   */
  clearAll () {
    localStorage.clear()
  }
}
